// Helper for admin console. Provides an "impersonate" action that saves the
// current admin token, swaps in a target user's token, and navigates to that
// user's console. Combined with <ImpersonationBanner /> in each console
// layout, this gives Heritage admins a one click way to test other consoles.
import { api } from '@/lib/api';

export async function startImpersonation(userId, { navigate, refreshAuth }) {
  const adminToken = localStorage.getItem('h_token');
  const { data } = await api.post(`/admin/impersonate/${userId}`);
  if (adminToken) localStorage.setItem('h_admin_backup', adminToken);
  localStorage.setItem('h_token', data.token);
  await refreshAuth();
  const role = data.user?.role;
  const dest =
    role === 'founder' ? '/console/founder' :
    role === 'ambassador' ? '/console/ambassador' :
    role === 'member' ? '/console/customer' :
    '/admin';
  navigate(dest);
}
